import { inject, Injectable } from '@angular/core';
import { Observable, combineLatest, map } from 'rxjs';
import { SalesSessionPort, SalesSessionContext } from '../../domain/ports/sales-session.port';
import { SERVICE_STORE } from '@features/service/domain/tokens/service-store.token';
import { ACCOUNT_STORE } from '@core/entities/account/domain/tokens/account-store.token';
import { AppContextService } from '@shared/services/app-context/app-context.service';

@Injectable({ providedIn: 'root' })
export class SalesSessionAdapter implements SalesSessionPort {
    private readonly serviceStore = inject(SERVICE_STORE);
    private readonly accountStore = inject(ACCOUNT_STORE);
    private readonly appContext = inject(AppContextService);

    getSessionContext(): Observable<SalesSessionContext> {
        return combineLatest([
            this.accountStore.getSelectedAccount$(),
        ]).pipe(
            map(([account]) => {
                const { selection } = this.serviceStore.state();

                if (!account || !selection) {
                    throw new Error('Missing session context for sales');
                }

                return {
                    accountId: account.id,
                    waiterId: selection.worker?.id ?? '',
                    locationId: selection.location?.id ?? '',
                    cashDrawerId: selection.drawer?.id ?? '',
                    serviceId: this.appContext.serviceId,
                };
            })
        );
    }
}
